import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

export enum SplitMethod {
    AMOUNT = "splitByAmount",
    SHARE = "splitByShare",
    PERCENTAGE = "splitByPercentage",
}

export interface Contact {
    name: string;
    number: string;
    avatar?: string;
}

/** Self + guests without scanning the full list for `SELF_IDENTIFIER` in UI. */
export interface SplitBillContactsView {
    self: Contact;
    guests: Contact[];
}

export interface GuestSplitData {
    percentage: number;
    amount: number;
    share: number;
}

export type GuestSplitsMap = Record<string, GuestSplitData>;

// Split Bill API Types
export interface SplitBillPayerInfo {
    userId: string;
    name: string;
    upiId: string;
    payerShareAmount: number;
}

export interface SplitBillSplitInfo {
    phoneNumber: string;
    amount: number;
    name: string;
}

export interface SplitBillConfirmData {
    method: SplitMethod;
    splits: Record<string, number>;
    billAmount: number;
    dineCashAmount: string;
    splitDineCash: boolean;
}

export interface SplitBillApiRequest {
    orderId: string;
    totalBillAmount: number;
    dineCashAmount: number;
    splitDineCash: boolean;
    payer: SplitBillPayerInfo;
    splits: SplitBillSplitInfo[];
}

export interface ISplitBillWarningCallout {
    iconId: string;
    text: string;
    textColor: keyof IColors;
    backgroundColor: keyof IColors;
    iconColor: keyof IColors;
}

/** Inner `data` object from POST `/api/v1/dash/oms/split-bill-comms` success response. */
export interface ISplitBillCommsSuccessData {
    statusCode: number;
    statusTitle: string;
    statusMessage: string;
    currentSplitWidgetState: string;
    warningCallout?: ISplitBillWarningCallout;
}

/** Top-level POST `/api/v1/dash/oms/split-bill-comms` response envelope. */
export interface SplitBillApiResponse {
    statusCode: number;
    statusMessage: string;
    data: ISplitBillCommsSuccessData | null;
}
